export default "__VITE_ASSET__e3Lz_frG__"